


























































































































































































































import { Component, Mixins, Provide, Ref, Watch } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import QuestionMixins from '@/mixins/QuestionMixins';
import { mapState } from 'vuex';
import QConditionalQuestion from './partial/QConditionalQuestion.vue';
import CandidateQuestionnaireCandidateProfileCheck from './CandidateQuestionnaireCandidateProfileCheck.vue';
import CandidateQuestionnaireGuardianInfo from './CandidateQuestionnaireGuardianInfo.vue';
import CandidateQuestionnaireDeclaration from './CandidateQuestionnaireDeclaration.vue';
import QQuestionnaireLayout from '@/components/Questionnaire/QQuestionnaireLayout.vue';
import { STATUSES } from '@/constants/questionnaire_answer.js';
import { BOOKING_PURPOSES } from '../../../constants/booking';

@Component({
  components: {
    QConditionalQuestion,
    CandidateQuestionnaireCandidateProfileCheck,
    CandidateQuestionnaireGuardianInfo,
    CandidateQuestionnaireDeclaration,
    QQuestionnaireLayout,
  },
  computed: {
    ...mapState('QuestionnaireAnswer', {
      questionnaireAnswer: 'questionnaireAnswer',
      questionnaire: 'questionnaire',
    }),
    ...mapState({
      loading: 'loading',
    }),
  },
})
export default class CandidateQuestionnaire extends Mixins(
  CRUDMixins,
  QuestionMixins
) {
  @Provide() isPreview = false;
  @Ref() questionComponent!: QConditionalQuestion;

  questionnaireAnswer!: Model;
  questionnaire!: Model;
  loading!: boolean;

  question: Model | null = null;
  questionGroupOid = null;

  reload = 0;

  isMounted = false;
  ready = false;
  showResult = false;
  declarationDialog = false;
  showErrorDialog = false;
  hasShowCompleteDialog = false;
  isShowCompleteDialog = false;
  isShowIncompleteDialog = false;

  questionIndex = 0;
  questionGroupIndex = 0;
  questionGroupQuestions = [];

  @Watch('isCompleted', { immediate: true })
  watchIsCompleted(newVal) {
    // Change the label from 'Save & Exit' to 'Complete'
    this.updateActions();

    // If isCompleted = true
    if (newVal) {
      // If showResult = false, disable update action (Complete button)
      if (!this.showResult) {
        this.disableActions(['UPDATE']);
      }
    }
  }

  @Watch('showResult', { immediate: true })
  watchShowResult() {
    // If showResult is changed, start checking what actions need to be disabled
    this.disableActions();
  }

  @Watch('isXs')
  watchIsXsAndDown() {
    this.updateActions();
  }

  created() {
    // Disable read and update by default
    this.disableActions(['READ', 'UPDATE']);

    this.$store.commit('QuestionnaireAnswer/CLEAR_STATE');
  }

  async beforeMount() {
    // Fetch the questionnaire answer model with the questionn answers
    await this.$store
      .dispatch('QuestionnaireAnswer/fetch', this.$route.params.beOid)
      .then(async () => {
        await this.fetchQuestion();

        if (this.isLastQuestionGroup && this.isCompleted) {
          await this.read();
        }

        this.isMounted = true;
      })
      .catch(({ response }) => {
        console.error(response);
        this.showErrorDialog = true;
      });
  }

  get isPending() {
    return this.questionnaireAnswer.status === STATUSES.STATUS_PENDING.key;
  }

  get isUnderage() {
    return (
      this.questionnaireAnswer.status ===
      STATUSES.STATUS_REQUIRE_GUARDIAN_INFO.key
    );
  }

  get isCompleted() {
    return this.progress?.every((p) => p == 100);
  }

  get showContent() {
    return (
      !this.isPending &&
      !this.isUnderage &&
      this.questionGroups.length > 0 &&
      this.questionGroupIndex < this.questionGroups.length &&
      !this.showResult &&
      this.activeQuestionGroup
    );
  }

  get questionGroups() {
    return (
      this.questionnaire.question_groups.map(
        this.$store.getters['Questionnaire/mapQuestionGroup']
      ) || []
    );
  }

  get activeQuestionGroupIndex() {
    if (!this.questionGroupOid) {
      return this.questionGroups.length;
    }
    return this.questionGroups.findIndex(
      (qg) => qg.object_id === this.questionGroupOid
    );
  }

  get activeQuestionGroup() {
    if (!this.questionGroupOid) {
      return null;
    }
    return this.questionGroups.find(
      (qg) => qg.object_id === this.questionGroupOid
    );
  }

  get progress() {
    return this.questionnaire?.question_groups?.map((group) => {
      if (!group.object_id) {
        return 100;
      }

      return parseFloat(group.progress) * 100;
    });
  }

  get questionGroupResult() {
    return this.questionnaire.question_groups.map(
      this.$store.getters['Questionnaire/mapQuestionGroup']
    );
  }

  get isEmptyQuestionGroup() {
    return (
      this.activeQuestionGroup.progress === 1 &&
      (this.activeQuestionGroup.questions?.length === 0 ||
        !this.activeQuestionGroup.questions) &&
      !this.loading
    );
  }

  get isLastQuestionGroup() {
    return this.questionGroupIndex + 1 == this.questionGroups.length;
  }

  get isLastQuestion() {
    return this.questionIndex + 1 == this.questionGroupQuestions.length;
  }

  get isXs() {
    return this.$vuetify.breakpoint.xs;
  }

  get changeAnswerBtnLabel() {
    return this.isXs ? 'Change' : 'Change Answers';
  }

  get completeSubmitBtnLabel() {
    return this.isXs ? 'Complete' : 'Complete & Submit';
  }

  // 'Review' button action
  async read() {
    this.isShowCompleteDialog = false;
    this.showResult = !this.showResult;
    if (this.showResult) {
      await this.fetchResult();
    } else {
      this.question = null;
      this.fetchQuestion(this.questionGroups[0].object_id, 0);
    }
    this.updateActions();
  }

  // 'Save & Exit'/'Complete' button action
  async update() {
    if (this.isCompleted) {
      this.declarationDialog = true;
    } else if (!this.isCompleted) {
      await this.questionComponent.nextQuestion();

      if (this.$route.meta.redirect) {
        this.$emit('route-go-back');
      }
    }
  }

  async complete() {
    await this.$store
      .dispatch('QuestionnaireAnswer/complete')
      .then(() => {
        const resolved = this.$router.resolve({
          name: 'candidate-booking-candidate-read',
          params: {
            bookingCandidateOid: this.$route.params.beOid,
          },
        });

        this.$router.push({
          name: 'candidate-thank-you',
          params: {
            redirectRoute: resolved.route as never,
          },
        });

        if (
          this.questionnaire.booking.type ===
          BOOKING_PURPOSES.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
        ) {
          this.$store.commit('Feedback/SET_STATE', {
            key: 'popup',
            payload: true,
          });
        }
      })
      .catch(({ response }) => {
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: response?.data?.error,
        });
      });
  }

  checkShowCompleteDialog() {
    if (this.isCompleted && !this.hasShowCompleteDialog) {
      this.isShowCompleteDialog = true;
      this.hasShowCompleteDialog = true;
    }
  }

  remindMeLater() {
    this.isShowCompleteDialog = false;
    this.hasShowCompleteDialog = false;
  }

  nextQuestion(payload) {
    // Update the progress data in the questionnaire answer
    this.$store.commit('QuestionnaireAnswer/UPDATE_PROGRESS', payload);

    // go to review if current question is the last one in the last question group and all the questions have been answered
    if (this.isLastQuestionGroup && this.isLastQuestion && this.isCompleted) {
      return this.read();
    }

    this.questionGroupQuestions = payload.question_group_available_questions;
    this.questionGroupOid = payload.question_group_object_id;
    this.questionIndex = payload.question_offset;
    this.questionGroupIndex = payload.question_group_offset;

    if (!this.isLastQuestionGroup) {
      this.checkShowCompleteDialog();
    }

    if (this.question?.object_id === payload.question?.object_id) {
      this.isShowIncompleteDialog =
        this.isLastQuestionGroup && this.isLastQuestion && !this.isCompleted;
    }

    if (!payload.question) {
      this.question = null;
    } else {
      this.question = this.$store.getters['Questionnaire/mapQuestion'](
        payload.question
      );
    }
    this.reload++;
  }

  async fetchQuestion(questionGroupOid = null, offset: number | null = null) {
    if (this.loading) {
      return;
    }
    await this.$store
      .dispatch('QuestionnaireAnswer/fetchNextQuestion', {
        params: {
          question_group: questionGroupOid,
          offset: offset,
        },
      })
      .then((response) => {
        this.questionGroupQuestions =
          response.data.data.question_group_available_questions;

        // Update the progress data in the questionnaire answer
        this.$store.commit(
          'QuestionnaireAnswer/UPDATE_PROGRESS',
          response.data.data
        );

        this.questionIndex = response.data.data.question_offset;
        this.questionGroupIndex = response.data.data.question_group_offset;
        this.questionGroupOid = response.data.data.question_group_object_id;

        if (response.data.data.progress == 1) {
          this.questionGroupOid = this.questionGroups[
            this.questionGroupIndex
          ].object_id;
        }

        if (!response.data.data.question) {
          this.question = null;
        } else {
          this.question = this.$store.getters['Questionnaire/mapQuestion'](
            response.data.data.question
          );
        }
        this.reload++;
      });
    this.showResult = false;
  }

  async fetchResult() {
    if (this.loading) {
      return;
    }
    await this.$store.dispatch(
      'QuestionnaireAnswer/fetchResultForReview',
      this.questionnaireAnswer.object_id
    );
    this.updateActions();
    this.showResult = true;
    this.isMounted = true;
  }

  async confirmCandidateProfile() {
    await this.$store.dispatch(
      'QuestionnaireAnswer/confirmCandidateProfile',
      this.$route.params.beOid
    );
    this.fetchQuestion();
  }

  disableActions(actions: string[] = []) {
    // If isCompleted = true and showResult = true, do not disable any top bar actions
    if (this.isCompleted && this.showResult) {
      actions = [];
      // If isCompleted = true but showResult = false, only disable the update action (Complete button)
    } else if (this.isCompleted) {
      actions = ['UPDATE'];
    }
    this.$emit('disable-actions', actions);
  }

  updateActions() {
    const actions: any[] =
      this.isCompleted && this.showResult
        ? this.$route.meta
            .appBarActions()
            .map((item) => ({ ...item, hidden: true })) // hide the app bar action buttons
        : this.$route.meta.appBarActions();

    this.$emit('update-actions', actions);
  }

  activateQuestionGroup(index: number) {
    if (this.questionGroupIndex == index) {
      this.questionGroupIndex = -1;
      return;
    }
    this.fetchQuestion(this.questionGroups[index].object_id, 0);
  }

  activateQuestion(index: number) {
    if (this.questionIndex == index) {
      return;
    }
    this.fetchQuestion(
      this.questionGroups[this.questionGroupIndex].object_id,
      index
    );
  }

  submitGuardianInfo(v) {
    this.$store.dispatch('QuestionnaireAnswer/submitGuardianInfo', v);
  }
}
